$('.button_text').on('click', function () {
  $(this).next('.canvas_holder').fadeIn()
  $('body').addClass('no_scroll')
})

$('.close_canvas').on('click', function () {
  $(this).closest('.canvas_holder').fadeOut()
  $('body').removeClass('no_scroll')
})

$('.building__image:not(.disable)').on('click', function () {
  var slider = $(this).data('slider')
  $(slider)
    .fadeIn()
    .find('.external_slider')
    .slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: true,
    })
    .fadeIn()
  $(slider).find('.external_slider')[0].slick.slickGoTo(parseInt(1))
  $('.building_slider')
    .fadeIn()
    .css('display', 'flex')
    .find('.slick-prev, .slick-next')
    .html(
      '<span class="circle"><span><em></em></span><span><em></em></span></span>'
    )
})

$('.close_slider').on('click', function () {
  $(this).closest('.pop_up_slider').hide().closest('.building_slider').hide()
  $(this).next('.dhsv_vc_slider').find('.external_slider').slick('unslick')
})
